import React from "react";
import { Autocomplete } from "@mui/material";
import { CustomTextField } from "../formsComponents";
import { MuiTextFieldProps } from "@mui/lab/internal/pickers/PureDateInput";

interface RelationAutoSearchProps {
  value: string;
  label?: string;
  placeholder?: string;
  onChange: (value: string) => void;
  disabled?: boolean;
  isHighlighted?: boolean;
  sx?: MuiTextFieldProps["sx"];
  isSelftIncluded?: boolean;
}

const RELATION_OPTIONS = [
  "Father",
  "Mother",
  "Son",
  "Daughter",
  "Brother",
  "Sister",
  "Grandfather",
  "Grandmother",
  "Uncle",
  "Aunt",
  "Cousin",
  "Nephew",
  "Niece",
  "Friend",
];

const RELATION_OPTIONS_INCLUDING_SELF = [
  "Father",
  "Mother",
  "Son",
  "Daughter",
  "Brother",
  "Sister",
  "Grandfather",
  "Grandmother",
  "Uncle",
  "Aunt",
  "Cousin",
  "Nephew",
  "Niece",
  "Friend",
  "Self",
];

const RelationAutoSearch: React.FC<RelationAutoSearchProps> = ({
  value,
  label = "Relation with Customer",
  placeholder = "Search or type relation",
  onChange,
  disabled = false,
  isHighlighted = false,
  sx,
  isSelftIncluded = false,
}) => {
  return (
    <Autocomplete
      freeSolo
      disableClearable
      options={
        isSelftIncluded ? RELATION_OPTIONS_INCLUDING_SELF : RELATION_OPTIONS
      }
      value={value || ""}
      disabled={disabled}
      onChange={(event, newValue) => {
        // Selecting from dropdown
        onChange(newValue || "");
      }}
      onInputChange={(event, newInputValue, reason) => {
        // Typing custom value
        if (reason === "input") {
          onChange(newInputValue);
        }
      }}
      sx={{
        ...sx,
        ".MuiOutlinedInput-root": {
          paddingTop: "1.5px",
          paddingBottom: "1.5px",
          fontSize: "0.8rem",
          color: "rgb(38, 38, 38)",
          width: "100%",
        },

        // Active filter highlight styles
        ...(isHighlighted && {
          "& .MuiOutlinedInput-root": {
            backgroundColor: "#fff2c7",
          },
          "& .MuiOutlinedInput-root .MuiOutlinedInput-notchedOutline": {
            borderColor: "warning.main",
            borderWidth: "2px !important",
          },
          "& .MuiOutlinedInput-root:hover .MuiOutlinedInput-notchedOutline": {
            borderColor: "warning.main",
          },
          "& .MuiOutlinedInput-root.Mui-focused .MuiOutlinedInput-notchedOutline":
          {
            borderColor: "warning.main",
          },
          "& .MuiOutlinedInput-input": {
            color: "#000000",
          },
        }),
      }}
      noOptionsText="Press Enter to add new relation"
      renderInput={(params) => (
        <CustomTextField
          {...params}
          label={label}
          placeholder={placeholder}
          fullWidth
          InputLabelProps={{
            shrink: true,
          }}
        />
      )}
    />
  );
};

export default RelationAutoSearch;
